import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';

import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import WhatsAppFab from './components/WhatsAppFab';
import { Toaster } from './components/ui/sonner';
import { CartProvider } from './context/CartContext';
import { WhatsAppProvider } from './context/WhatsAppContext';

import Home from './pages/Home';
import Login from './pages/Login';
import Registro from './pages/Registro';
import RecuperarPassword from './pages/RecuperarPassword';
import ResetPassword from './pages/ResetPassword';
import EstudiosSimple from './pages/EstudiosSimple';
import Sucursales from './pages/Sucursales';
import Promociones from './pages/Promociones';
import Resultados from './pages/Resultados';
import Facturacion from './pages/Facturacion';
import Blog from './pages/Blog';
import Agendar from './pages/Agendar';
import Dashboard from './pages/Dashboard';
import Carrito from './pages/Carrito';
import Checkout from './pages/Checkout';
import AcercaDe from './pages/AcercaDe';
import Terminos from './pages/Terminos';
import Privacidad from './pages/Privacidad';
import AvisoPrivacidad from './pages/AvisoPrivacidad';
import BlogPost from './pages/BlogPost';
import AdminPanel from './pages/AdminPanel';
import EstudioEditor from './pages/EstudioEditor';
import BlogPostEditor from './pages/BlogPostEditor';
import ContadorPanel from './pages/ContadorPanel';

function App() {
  return (
    <CartProvider>
      <WhatsAppProvider>
        <div className="App">
          <BrowserRouter>
            <ScrollToTop />
            <Navbar />
            <Toaster />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/login" element={<Login />} />
              <Route path="/registro" element={<Registro />} />
              <Route path="/recuperar-password" element={<RecuperarPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/estudios" element={<EstudiosSimple />} />
              <Route path="/sucursales" element={<Sucursales />} />
              <Route path="/promociones" element={<Promociones />} />
              <Route path="/resultados" element={<Resultados />} />
              <Route path="/facturacion" element={<Facturacion />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/blog/:id" element={<BlogPost />} />
              <Route path="/agendar" element={<Agendar />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/carrito" element={<Carrito />} />
              <Route path="/checkout" element={<Checkout />} />
              <Route path="/acerca-de" element={<AcercaDe />} />
              <Route path="/terminos" element={<Terminos />} />
              <Route path="/privacidad" element={<Privacidad />} />
              <Route path="/aviso-privacidad" element={<AvisoPrivacidad />} />
              <Route path="/admin" element={<AdminPanel />} />
              <Route path="/admin/estudio/:id" element={<EstudioEditor />} />
              <Route path="/blog/editor/:id" element={<BlogPostEditor />} />
              <Route path="/contador" element={<ContadorPanel />} />
            </Routes>
            <Footer />
            <WhatsAppFab />
          </BrowserRouter>
        </div>
      </WhatsAppProvider>
    </CartProvider>
  );
}

export default App;